<template>
  <div id="app" v-if="stationData">
    <Wrapper
      v-bind:src="stationData.intro_track"
      v-bind:heading="stationData.heading"
      v-on:exit="exitStation"
      nr="7"
    >
      <p slot="intro">{{ stationData.intro_text }}</p>
      <div class="content">
        <P5vue v-bind:color="this.stationData['color-main']" />
        <p class="explanation">
          {{ stationData.explanation }}
          <button
            v-if="!exited && showExitButton"
            class="btn"
            @click="exitStation"
          >
            {{ $t("exitButton.label") }}
          </button>
          <button
            v-if="!exited && showAudioButton"
            class="btn"
            @click="playAudio"
          >
            {{ $t("playRecording") }}
          </button>
        </p>
        <InfoButton
          class="info-button"
          v-if="showInfoButton"
          :id="infoButtonId"
        />
      </div>
    </Wrapper>
  </div>
</template>

<script>
import axios from "axios";
import i18n from "./i18n";
import Wrapper from "ne01-common/src/components/Wrapper";
import P5vue from "./components/P5vue";
import InfoButton from "ne01-common/src/components/InfoButton";
import { Howl } from "howler";

export default {
  name: "app",
  components: {
    Wrapper,
    P5vue,
    InfoButton,
  },
  mounted() {
    if (!window.apiUrl) {
      window.apiUrl = "https://lasauge.bird-song.ch";
    }
    if (!window.cmsUrl) {
      window.cmsUrl = "https://wp.ls.bird-song.ch";
    }
    if (!window.cmsSlug) {
      window.cmsSlug = "station-7";
    }

    this.visitorId =
      new URL(window.location.href).searchParams.get("visitor") || 1;
    const lang = new URL(window.location.href).searchParams.get("lang") || "de";
    i18n.locale = lang;

    this.startTime = Date.now();

    this.loadData();

    this.showAudioButton = true;
  },
  data: () => {
    return {
      currentComponent: "Intro",
      stationData: null,
      startTime: 0,
      exited: false,
      visitorId: 1,
      showExitButton: false,
      showAudioButton: false,
      showInfoButton: false,
    };
  },
  methods: {
    loadData() {
      let url = `${window.cmsUrl}/wp-json/wp/v2/stations?slug=${window.cmsSlug}&lang=${i18n.locale}`;
      return new Promise((resolve, reject) => {
        axios.get(url).then((response) => {
          this.stationData = response.data[0];
          resolve();
        });
      });
    },
    playAudio() {
      this.showAudioButton = false;
      this.showInfoButton = true;
      if (!this.stationData.recording) return;
      this.sound = new Howl({ src: this.stationData.recording });
      this.sound.play();

      setTimeout(() => {
        this.showExitButton = true;
      }, 10000);
    },
    exitStation() {
      this.exited = true;

      const seconds = Date.now() - this.startTime;
      let dScore = 1;
      if (seconds < 1200000) {
        dScore = seconds / 1200000;
      }

      axios
        .post(window.apiUrl + "/api/scores", {
          station_id: 7,
          visitor_id: this.visitorId,
          score: 0,
          duration: dScore,
          activity: 0,
        })
        .then(() => {
          window.postMessage("end");
        });
    },
  },
  computed: {
    infoButtonId() {
      if(this.$i18n.locale == 'fr') {
        return 1394;
      }
      return 1393;
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Syntax", Helvetica, Arial, sans-serif;
  font-size: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
}
.content {
  padding: 4rem;
  box-sizing: border-box;
  font-family: "Syntax";
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}
.explanation {
  position: absolute;
  text-align: center;
  left: 7rem;
  right: 7rem;
  font-size: 1.3rem;
  top: 40vw;
  box-sizing: border-box;
  line-height: 1.7;
}

.btn {
  margin-top: 3rem;
  background: var(--dark);
  border: none;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: calc(1rem * 1.5);
  color: var(--light);
  font-size: 2rem;
  font-family: "GT Sectra";
  text-align: center;
  text-decoration: none;
  -webkit-font-smoothing: antialiased;

  &--secondary {
    font-size: 1.25rem;
    padding: 1rem;
    background-color: #fffdf9;
    color: #212121;
  }
}

.info-button {
  position: absolute;
  bottom: 1rem;
  right: var(--gutter);
  width: 80%;
}

.wrapper--isIntroDone {
  background-image: linear-gradient(#1f1f1f, #0c0c0c);
}
.wrapper--isIntroDone .station-header {
  transition: background 300ms linear;
  background: #000;
  color: #888;
}
.wrapper--isIntroDone .station-header__exit {
  background-image: url("./assets/icon-exit.svg");
}
.wrapper--isIntroDone .explanation {
  color: #fffdf9;
}
</style>
